// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"qi_a bhh_su bhh_kv bhh_kw","PostDetailRight__brandDaysPosts":"qi_b bhh_su bhh_kv bhh_kw"};